import { Button, Label, Modal, type ModalProps,Textarea } from 'flowbite-react';
import { CheckIcon, ListCheckIcon } from 'lucide-react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

interface FormData {
    contents: string;
}

export interface ShortcutImportModalProps extends ModalProps {
    onImport: (data: Array<{ shortcut: string; meaning: string }>) => void;
}

export const ShortcutImportModal = ({
    show,
    onImport,
    onClose
}: ShortcutImportModalProps) => {
    const { register, formState: { errors }, getValues } = useForm<FormData>({
        defaultValues: {
            contents: ''
        },
    });

    const handleImport = useCallback(() => {
        const values = getValues();
        const contents = values.contents.split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0)
            .map(line => {
                let shortcut = line;
                let meaning = line;

                const match = line.match(/^(\w+)\s*(?:[\-—:])?\s*?(.*)$/);

                if (match) {
                    shortcut = match[1];
                    meaning = match[2];
                }

                return {
                    shortcut: shortcut.trim(),
                    meaning: meaning.trim(),
                };
            });

        onImport(contents);
        onClose?.();
    }, [ onImport, onClose ]);

    return (
        <Modal show={show} size="2xl" onClose={onClose} popup>
            <Modal.Header>
                <span className="flex flex-row items-start md:items-center leading-5 justify-center gap-2 p-3 text-base md:text-lg font-semibold text-gray-800 dark:text-gray-400">
                    <ListCheckIcon size={20} className='flex-shrink-0' />
                    <span>Hromadné vložení zkratek</span>
                </span>
            </Modal.Header>
            <Modal.Body>
                <div className='w-full mb-4'>
                    <Label htmlFor="source" className="block mb-1">Zadejte na každý řádek jednu zkratku:</Label>
                    <Textarea
                        id="source"
                        placeholder={[
                            'AI umělá inteligence',
                            'ML - strojové učení',
                            'NLP: zpracování přirozeného jazyka',
                            'LLM    velký jazykový model',
                        ].join('\n')}
                        {...register('contents', {
                            maxLength: { value: 30000, message: 'Max. délka je 30000 znaků.' },
                            required: { value: true, message: 'Toto pole je povinné.' },
                        })}
                        rows={16}
                        className='grow w-full overflow-auto whitespace-pre'
                        color={errors.contents ? 'failure' : 'default'}
                        helperText={(
                            <>
                                {errors.contents && (
                                    <p>
                                        {errors.contents.message}
                                    </p>
                                )}
                            </>
                        )}
                    />
                </div>

                <div className='flex flex-col items-stretch gap-2'>
                    <div className='flex flex-row items-center justify-end gap-2'>
                        <Button
                            color="gray"
                            onClick={onClose}
                        >Zavřít</Button>

                        <div className='flex-grow' />

                        <Button
                            color='primary'
                            size='sm'
                            className='flex-shrink-0'
                            onClick={handleImport}
                        ><CheckIcon size={18} /> <span className='ml-2'>Vložit</span></Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
